<!-- 盘点明细操作弹框 -->
<template>
    <van-overlay :show="show" @click="onSendClose">
        <div class="content" v-if="info" @click.stop>
            <div class="tool">
                <label>盘点操作</label>
                <i class="iconfont guanbi" @click="onSendClose"></i>
            </div>
            <div class="content-main flex-wrap">
                <div class="goods-info flex-wrap">
                    <section>商品名称 : {{info.barCode}}</section>
                    <section>国际条码 : {{info.barCode}}</section>
                    <section>规格 : {{info.checkStockDetailExtendResponseVO.productSpec}}</section>
                    <section>效期 : {{info.productDate | dateSub}} ~ {{info.invalidDate | dateSub}}</section>
                    <section>商品状态 : {{info.checkStockDetailExtendResponseVO.productStatus?"不良品":"良品"}}</section>
                    <section>数量 : {{info.total}}</section>
                </div>
                <div class="check flex-wrap">
                    <section>
                        <label>盘点量</label>
                        <label>
                            <van-field
                                v-model="checkDoInfo.number"
                                type="number"
                                @input="onCheckNumChange"
                            />
                        </label>
                    </section>
                    <section>
                        <label>盘点效期</label>
                        <label
                            class="check-date-picker"
                            @click="showDatePicker=true"
                        >{{checkDoInfo.invalidDate?checkDoInfo.invalidDate:"YYYY-MM-DD"}}</label>
                    </section>
                    <section
                        class="exception"
                        v-show="checkDoInfo.exceptionFlag"
                    >** {{exceptionText}} **</section>
                    <section v-show="checkDoInfo.exceptionFlag">
                        <label>异常原因</label>
                        <label>
                            <van-field v-model="checkDoInfo.exceptionMemo"/>
                        </label>
                    </section>
                </div>
                <div class="info-sub flex">
                    <label @click="onCheckInfoSub" :class="subButtonDisable?'disalble':''">保存</label>
                </div>
            </div>
        </div>
        <div class="date-picker" @click.stop v-if="showDatePicker">
            <van-datetime-picker
                :item-height="30"
                v-model="currentDate"
                type="date"
                @confirm="onDateSure"
                @cancel="showDatePicker=false"
            />
        </div>
    </van-overlay>
</template>

<script>
import DataFormat from "../util/dataFormat.js";
export default {
    data() {
        return {
            currentDate: new Date(),
            showDatePicker: false,
            exceptionText:"", // 异常提示语
            checkDoInfo: {
                number: "",
                invalidDate: "",
                exceptionFlag: false, // 是否为异常盘点
                exceptionMemo: "" // 异常原因
            }, // 盘点数据
            subButtonDisable:false, // 禁用提交按钮
        };
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    components: {},
    mounted() {},
    methods: {
        // 发送关闭事件
        onSendClose() {
            this.$emit("closeDialog");
        },
        // 效期选择
        onDateSure(value) {
            this.showDatePicker = false;
            console.log(DataFormat.dateFormat("YYYY-mm-dd", value));
            this.checkDoInfo.invalidDate = DataFormat.dateFormat(
                "YYYY-mm-dd",
                value
            );
            console.log(this.info.invalidDate);
            console.log(this.checkDoInfo.invalidDate);
            let invalidDateTmp = this.info.invalidDate.substr(0, 10);
            if(this.checkDoInfo.invalidDate!=invalidDateTmp){
              this.checkDoInfo.exceptionFlag = true;
              this.exceptionText = "盘点效期与板上商品效期不一致,盘点存在异常";
            } else {
              this.checkDoInfo.exceptionFlag = false;
            }
        },
        // 盘点数量变化
        onCheckNumChange(value) {
            if (this.info.total != this.checkDoInfo.number) {
                this.checkDoInfo.exceptionFlag = true;
                this.exceptionText = "盘点数量与板上商品数量不一致,盘点存在异常";
            } else {
                this.checkDoInfo.exceptionFlag = false;
            }
        },
        // 盘点保存成功发送事件
        sendSaveSuccess(){
          this.$emit("checkDetailResultSaveSuccess");
        },
        // 明细盘点结果保存
        onCheckInfoSub() {
            if (!this.checkDoInfo.number) {
                this.$toast.fail("请填写盘点数量");
                return;
            }
            if (!this.checkDoInfo.invalidDate) {
                this.$toast.fail("请填写盘点效期");
                return;
            }
            let param = {
                id: this.info.id,
                checkId: this.info.checkId,
                checkQty: this.checkDoInfo.number,
                invalidDate: this.checkDoInfo.invalidDate,
                exceptionFlag: this.checkDoInfo.exceptionFlag,
                exceptionMemo: this.checkDoInfo.exceptionMemo
            };
            this.subButtonDisable = true;
            this.$post(this.URL.saveCheckDetailResult, param).then(res => {
                if (res.success) {
                    this.$toast.success("盘点成功");
                    this.sendSaveSuccess();
                } else {
                    this.$toast.fail(res.message);
                };
                this.subButtonDisable = false;
            });
        }
    }
};
</script>
<style lang='scss' scoped>
.van-overlay {
    padding: 3rem 1rem 1rem 1rem;
}
.content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    font-size: 0.85rem;
    box-sizing: border-box;
    background-color: white;
    border-radius: 0.3rem;
    color: #444;
    .tool {
        display: flex;
        width: 100%;
        justify-content: space-between;
        height: 2.6rem;
        align-items: center;
        padding: 0 0.5rem;
        font-size: 0.9rem;
        background-color: #dc6350;
        color: white;
        border-top-right-radius: 0.3rem;
        border-top-left-radius: 0.3rem;
        i {
            font-size: 0.9rem;
        }
    }
}
.content-main {
    padding: 0.5rem;
    .goods-info {
        padding: 0.5rem 0;
        border-bottom: 1px solid #f0f0f0;
        section {
            display: flex;
            width: 100%;
            height: 1.6rem;
            align-items: center;
        }
    }
    .check {
        padding: 0.8rem 0;
        section {
            display: flex;
            width: 100%;
            align-items: center;
            height: 2.5rem;
            align-items: center;
            label:first-child {
                width: 4rem;
            }
            .check-date-picker {
                border: 1px solid #f0f0f0;
                border-radius: 0.2rem;
                width: 13rem;
                padding-left: 0.5rem;
                line-height: 2rem;
                box-sizing: border-box;
            }
        }
        .exception {
            color: #dc6350;
        }
        .van-cell {
            padding: 0;
            border: 1px solid #f0f0f0;
            border-radius: 0.2rem;
            width: 13rem;
            padding-left: 0.5rem;
            line-height: 2rem;
        }
    }
    .info-sub {
        justify-content: center;
        padding-bottom: 0.5rem;
        label {
            display: inline-flex;
            width: 18rem;
            height: 2rem;
            background-color: #dc6350;
            color: white;
            justify-content: center;
            align-items: center;
            border-radius: 0.3rem;
        }
        .disalble{
          background-color: #f0f0f0;
          color: #444;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/checkControllerDialog.vue